import FormLookup from './form-lookup'

export default FormLookup